// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import * as React from "react";
import { useContext } from "react";

export interface OrderDetailsReleaseNumberStyles {
    titleText?: TypographyProps;
    releaseNumber?: TypographyProps;
    wrapper?: InjectableCss;
}

export const releaseNumberStyles: OrderDetailsReleaseNumberStyles = {
    wrapper: {
        ...xOrderInformationStyles.headingAndTextStyles?.wrapper,
    },
    titleText: {
        ...xOrderInformationStyles.headingAndTextStyles?.heading,
    },
    releaseNumber:{
        ...xOrderInformationStyles.headingAndTextStyles?.text,
    }
};

const styles = releaseNumberStyles;

const OrderDetailsReleaseNumber: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order || !order.properties.releaseNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsReleaseNumber">
                {translate("Release #")}
            </Typography>
            <Typography {...styles.releaseNumber} aria-labelledby="orderDetailsReleaseNumber">
                {order.properties.releaseNumber}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsReleaseNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
